<template>
  <div>
    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Resultado:</h4>
      </b-col>
      <b-col cols="10">
        <Resultado />
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Comportamiento Presupuestario:</h4>
      </b-col>
      <b-col cols="10"> <Comportamiento /> </b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Fuente y uso de fondos:</h4>
      </b-col>
      <b-col cols="10"> <Fondos /></b-col>
    </b-row>

    <b-row>
      <b-col class="col-title" cols="2">
        <h4 class="title-options">Indicadores financieros:</h4>
      </b-col>
      <b-col cols="10"> <Indicadores /></b-col>
    </b-row>
  </div>
</template>

<script>
import Resultado from "./buttons/Resultado";
import Comportamiento from "./buttons/Comportamiento";
import Fondos from "./buttons/Fondos";
import Indicadores from "./buttons/Indicadores";
export default {
  components: {
    Resultado,
    Comportamiento,
    Fondos,
    Indicadores,
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  margin-top: 20px;
}

.col-title {
  display: grid;
  justify-content: center;
  align-items: center;
}

.title-options {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}

@media screen and (max-width: 1600px) {
  .title-options {
    font-size: 20px;
    font-weight: 600;
  }
}

@media screen and (max-width: 1400px) {
  .title-options {
    font-size: 14px;
    font-weight: 600;
  }
}

@media screen and (max-width: 1000px) {
  .title-options {
    font-size: 12px;
    font-weight: 600;
  }
}

@media screen and (max-width: 662px) {
  .title-options {
    font-size: 8px;
    font-weight: 600;
  }
}
</style>
